import { useMemo } from 'react';

export interface WeekdayInfo {
	short: string;
	long: string;
}

export interface UseWeekdaysReturn {
	weekdays: WeekdayInfo[];
	weekdaysShort: string[];
	weekdaysLong: string[];
}

export const useWeekdays = (locale: string): UseWeekdaysReturn => {
	return useMemo(() => {
		// Find the most recent Sunday to use as base date
		const today = new Date();
		const dayOfWeek = today.getDay();
		const sundayDate = new Date(today);
		sundayDate.setDate(today.getDate() - dayOfWeek);

		// Generate all 7 days starting from Sunday (index 0)
		const allWeekdays = Array.from({ length: 7 }, (_, i) => {
			const date = new Date(sundayDate);
			date.setDate(sundayDate.getDate() + i);

			return {
				short: date.toLocaleString(locale, { weekday: 'short' }),
				long: date.toLocaleString(locale, { weekday: 'long' }),
			};
		});

		// Filter out weekends (Sunday = 0, Saturday = 6)
		const workdays = allWeekdays.filter((day, index) => ![0, 6].includes(index));

		return {
			weekdays: workdays,
			weekdaysShort: workdays.map((day) => day.short),
			weekdaysLong: workdays.map((day) => day.long),
		};
	}, [locale]);
};
